import { Redirect, Route } from "react-router-dom";

export default function PrivateRoute({ component: Component, user, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) =>
        user ? <Component {...props} user={user} /> : <Redirect to="/login" />
      }
    />
  );
}
